import { useCallback, useEffect, useState } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { Routes } from '@/core/router/routes'
import { download } from '../utils/biblioteca-actions'
import useClicks from '@/core/hooks/use-clicks'
import { ItemBiblioteca } from '@/core/types/graphql'
import { useGenerateDownloadLink } from '@/modules/biblioteca-virtual/hooks/use-generate-download-link'
import { SelectedItemBiblioteca } from '@/modules/biblioteca-virtual/types/types'

export const useSelectItem = ({
  setSearchText,
  generateDownloadLink
}: {
  setSearchText: (text: string) => void
  generateDownloadLink: ReturnType<
    typeof useGenerateDownloadLink
  >['generateDownloadLink']
}) => {
  const navigate = useNavigate()
  const params = useParams()

  const [selectedRows, setSelectedRows] = useState<SelectedItemBiblioteca[]>([])

  const resetSelection = useCallback(() => {
    setSelectedRows([])
  }, [])

  useEffect(() => {
    resetSelection()
  }, [params])

  const onSelectRow = (rowData: ItemBiblioteca) => {
    if (selectedRows.length === 0) {
      const updatedSelectedRows = [{ data: rowData, selected: true }]

      setSelectedRows(updatedSelectedRows)
    } else {
      const updatedSelectedRows = selectedRows.map(row => {
        if (row.data.id === rowData.id) {
          return { ...row, selected: !row.selected }
        }

        return row
      })

      const found = selectedRows.some(row => row.data.id === rowData.id)

      if (!found) {
        updatedSelectedRows.push({ data: rowData, selected: true })
      }

      setSelectedRows(updatedSelectedRows)
    }
  }

  const onClickRow = (row: ItemBiblioteca) => {
    const { id, isPasta } = row

    if (isPasta) {
      const input = document.getElementById(
        'searchInputBiblioteca'
      ) as HTMLInputElement
      if (input) {
        input.value = ''
      }
      setSearchText('')
      setSelectedRows([])
      navigate(generatePath(Routes.BIBLIOTECA_VIRTUAL_PASTA, { idPasta: id }))
    } else {
      download(generateDownloadLink, row)
    }
  }

  const { handleClick, handleDoubleClick } = useClicks({
    onClick: onSelectRow,
    onDoubleClick: onClickRow
  })

  return {
    handleClick,
    handleDoubleClick,
    resetSelection,
    selectedRows
  }
}
